"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useDataSource(selector) {
  const {
    item: dataSource,
    refresh,
    accessor,
    ...rest
  } = useElement(
    WorkspaceElementType.DataSource,
    selector,
    (integrationApp) => selector ? integrationApp.dataSource(selector) : void 0
  );
  async function reset() {
    await accessor?.reset();
    await refresh();
  }
  async function setup() {
    await accessor?.setup();
    await refresh();
  }
  return { dataSource, reset, refresh, setup, accessor, ...rest };
}

export { useDataSource };
